import ResponsiveImage from '~/components/Image/ResponsiveImage'

interface Props {
  img?: boolean
  value: number
  text: string
  imgSrcKey: string
}

const mediaQuery = [{ screen: '(min-width: 280px)', width: '80px' }]

export default function WindSurferScoreAndStreak({ img = true, value, text, imgSrcKey }: Props): React.ReactElement {
  return (
    <div className="w-full font-semibold rounded overflow-hidden shadow-card space-y-3 py-2 lg:mb-3 mb-4">
      <p className="text-center">
        <span className="text-purple">{text}</span>
      </p>
      {img && (
        <ResponsiveImage
          alt={text}
          imageClassName="mx-auto w-20 my-2"
          imageWidths="80, 100"
          mediaQuery={mediaQuery}
          srcKey={imgSrcKey}
        />
      )}
      <p className="text-center font-semibold">{value}</p>
    </div>
  )
}
